import { MediaType, validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { CLIENTE_ENDPOINT, FILTER_ENDPOINT, QCX_STORAGE_ENDPOINT, SERVICOS_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll() {
  return doGetQCXRequest([
    CLIENTE_ENDPOINT
  ]);
}

async function fetchById(id) {
  return doGetQCXRequest([
    CLIENTE_ENDPOINT,
    id
  ]);
}

async function fetchServicosByClienteId(id, queryParams = []) {
  return doGetQCXRequest(
    [
      CLIENTE_ENDPOINT,
      SERVICOS_ENDPOINT,
      id
    ],
    queryParams
  );
}

async function fetchDocumentosByClienteId(id) {
  return doGetQCXRequest([
    CLIENTE_ENDPOINT,
    id,
    "documentos"
  ]);
}

async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      CLIENTE_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

async function fetchClientesAssociadosACatalogoProdutos(params = []) {
  const validatedParams = validateQueryParams(params);
  return doGetQCXRequest([
    CLIENTE_ENDPOINT, "has/catalogoprodutos"
  ], validatedParams);
}

async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [CLIENTE_ENDPOINT],
    data,
    queryParams
  );
}

/**
 * O endpoint PUT, somente, usa request multipart por causa do certificado.
 * Requests multiparts não são usadas no POST porque o POST só ocorre na primeira
 * etapa e o campo do certificado fica em uma etapa posterior.
 */
async function save(data, queryParams = [], config = {}) {
  if (data instanceof FormData) {
    return doPutQCXRequest(
      [CLIENTE_ENDPOINT, 'updatewithcert'],
      data,
      queryParams,
      {
        ...config,
        headers: {
          'Content-Type': MediaType.MULTIPART_FORM_DATA,
        },
      }
    );
  }
  //
  // else:
  return doPutQCXRequest(
    [CLIENTE_ENDPOINT],
    data,
    queryParams,
    config
  );
}

async function associateModeloDanfe(idCliente, idModeloDanfe) {
  if (typeof idModeloDanfe !== 'string' && typeof idModeloDanfe !== 'number') {
    idModeloDanfe = -1; // Enviamos -1 para desassociar.
  }
  return doPutQCXRequest(
    [CLIENTE_ENDPOINT, 'updatemodelodanfe', idCliente, idModeloDanfe]
  );
}

async function activateById(id) {
  return doPutQCXActivateRequest(
    [CLIENTE_ENDPOINT],
    id
  );
}

async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [CLIENTE_ENDPOINT],
    id
  );
}

async function fetchClientesWithFilterDto(params = []) {
  const validatedParams = validateQueryParams(params);

  if (validatedParams.length) {
    return doGetQCXRequest([
      CLIENTE_ENDPOINT, "filter/dto"
    ], validatedParams);
  }
  return { data: [] };
}

async function removeServicoByIds(idCliente, idServico) {
  return doPutQCXRequest(
    [CLIENTE_ENDPOINT, "removeservico", idCliente, idServico]
  );
}

async function addDocumentTo(receiver, data, queryParams = [], config = {}) {
  return doPostQCXRequest([CLIENTE_ENDPOINT, receiver.id, QCX_STORAGE_ENDPOINT], data, queryParams, {
    ...config,
    headers: {
      'Content-Type': MediaType.MULTIPART_FORM_DATA,
    },
  });
}

async function updateDocumentTo(documentId, data, queryParams = [], config = {}) {
  return doPutQCXRequest([CLIENTE_ENDPOINT, 'documentos', documentId], data, queryParams, {
    ...config,
  });
}

async function deleteDocumentosByIds(clienteId, documentoIds) {
  const endpoint = [CLIENTE_ENDPOINT, clienteId, "deletedocs"];

  const payload = {
    documentoIds,
  };

  return doPutQCXRequest(
    endpoint,
    payload
  );
}

async function consultarCnpj(cnpj) {
  const data = {
    cnpj,
  };

  return doPostQCXRequest(
    [CLIENTE_ENDPOINT, 'consulta-cnpj'],
    data
  );

}

const clienteAPI = {
  fetchAll,
  fetchById,
  fetchByFilter,
  fetchServicosByClienteId,
  fetchDocumentosByClienteId,
  register,
  save,
  associateModeloDanfe,
  activateById,
  inactivateById,
  fetchClientesWithFilterDto,
  removeServicoByIds,
  consultarCnpj,
  addDocumentTo,
  updateDocumentTo,
  deleteDocumentosByIds,
};

export {
  clienteAPI,
  fetchAll,
  fetchById,
  fetchByFilter,
  fetchServicosByClienteId,
  fetchDocumentosByClienteId,
  register,
  save,
  associateModeloDanfe,
  activateById,
  inactivateById,
  fetchClientesWithFilterDto,
  fetchClientesAssociadosACatalogoProdutos,
  removeServicoByIds,
  consultarCnpj,
  addDocumentTo,
  updateDocumentTo,
  deleteDocumentosByIds,
};
